import { useQuery } from 'react-query';

import {
  TEACHER_STUDENT_EXERCISE,
  TEACHER_STUDENT_EXERCISE_VERSION_TITLE,
} from 'api/portfolioService/queries/v2/teacherStudentExercise';

import { portfolioServiceQueryClient } from 'utils/graphqlQueryClients';

export const useTeacherStudentExercise = (
  { exerciseVersionId, studentId },
  exerciseVersionTitleOnly = false,
) => {
  const query = exerciseVersionTitleOnly
    ? TEACHER_STUDENT_EXERCISE_VERSION_TITLE
    : TEACHER_STUDENT_EXERCISE;
  const response = useQuery(
    ['teacherStudentExercise', exerciseVersionId, studentId],
    () =>
      portfolioServiceQueryClient.request(query, {
        exerciseVersionId,
        studentId,
      }),
  );

  return {
    ...response,
    data: response?.data?.v2TeacherStudentExercise,
  };
};
